/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../src/app/search-panel/components/search-form-fulltext.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../src/app/search-panel/services/search-form.service';
import * as import10 from 'ng2-translate/src/translate.pipe';
import * as import11 from '@angular/core/src/linker/view_container';
import * as import12 from 'ng2-translate/src/translate.service';
import * as import13 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/default_value_accessor.ngfactory';
import * as import14 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/reactive_directives/form_control_directive.ngfactory';
import * as import15 from '../../../../../$$_gendir/node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import16 from '../../../../../$$_gendir/node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import17 from '@angular/core/src/linker/element_ref';
import * as import18 from '@angular/core/src/linker/template_ref';
import * as import19 from '@angular/forms/src/directives/default_value_accessor';
import * as import20 from '@angular/forms/src/directives/control_value_accessor';
import * as import21 from '@angular/forms/src/directives/reactive_directives/form_control_directive';
import * as import22 from '@angular/forms/src/directives/ng_control';
import * as import23 from '@angular/forms/src/directives/ng_control_status';
import * as import24 from '@angular/common/src/directives/ng_if';
export class Wrapper_SearchFormFulltextComponent {
  /*private*/ _eventHandler:Function;
  context:import0.SearchFormFulltextComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.SearchFormFulltextComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_fulltextFormControl(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.fulltextFormControl = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_SearchFormFulltextComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_SearchFormFulltextComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.SearchFormFulltextComponent>;
  _SearchFormFulltextComponent_0_3:Wrapper_SearchFormFulltextComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SearchFormFulltextComponent_Host0,renderType_SearchFormFulltextComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'obpa-search-form-fulltext',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_SearchFormFulltextComponent0(this.viewUtils,this,0,this._el_0);
    this._SearchFormFulltextComponent_0_3 = new Wrapper_SearchFormFulltextComponent(this.injectorGet(import9.SearchFormService,this.parentIndex));
    this.compView_0.create(this._SearchFormFulltextComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._SearchFormFulltextComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.SearchFormFulltextComponent) && (0 === requestNodeIndex))) { return this._SearchFormFulltextComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._SearchFormFulltextComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const SearchFormFulltextComponentNgFactory:import8.ComponentFactory<import0.SearchFormFulltextComponent> = new import8.ComponentFactory<import0.SearchFormFulltextComponent>('obpa-search-form-fulltext',View_SearchFormFulltextComponent_Host0,import0.SearchFormFulltextComponent);
const styles_SearchFormFulltextComponent:any[] = ([] as any[]);
class View_SearchFormFulltextComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _map_3:any;
  _pipe_translate_0:import10.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import11.ViewContainer) {
    super(View_SearchFormFulltextComponent1,renderType_SearchFormFulltextComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import1.UNINITIALIZED;
    this._map_3 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {chars: p0};
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','help-block'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import10.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n            ',valUnwrapper.unwrap(this._pipe_translate_0.transform('FORM: INVALID FULLTEXT',this._map_3(3))),'\n        ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_SearchFormFulltextComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_SearchFormFulltextComponent,{});
export class View_SearchFormFulltextComponent0 extends import2.AppView<import0.SearchFormFulltextComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _DefaultValueAccessor_5_3:import13.Wrapper_DefaultValueAccessor;
  _NG_VALUE_ACCESSOR_5_4:any[];
  _FormControlDirective_5_5:import14.Wrapper_FormControlDirective;
  _NgControl_5_6:any;
  _NgControlStatus_5_7:import15.Wrapper_NgControlStatus;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import11.ViewContainer;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import16.Wrapper_NgIf;
  _text_10:any;
  _text_11:any;
  /*private*/ _expr_20:any;
  /*private*/ _expr_21:any;
  _pipe_translate_0:import10.TranslatePipe;
  /*private*/ _expr_23:any;
  /*private*/ _expr_24:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_SearchFormFulltextComponent0,renderType_SearchFormFulltextComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_20 = import1.UNINITIALIZED;
    this._expr_21 = import1.UNINITIALIZED;
    this._expr_23 = import1.UNINITIALIZED;
    this._expr_24 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'label',new import3.InlineArray2(2,'for','obpa_fulltext'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_5 = import3.createRenderElement(this.renderer,this._el_0,'input',new import3.InlineArray8(6,'aria-describedby','obpa_fulltext_err','class','form-control','id','obpa_fulltext'),(null as any));
    this._DefaultValueAccessor_5_3 = new import13.Wrapper_DefaultValueAccessor(this.renderer,new import17.ElementRef(this._el_5));
    this._NG_VALUE_ACCESSOR_5_4 = [this._DefaultValueAccessor_5_3.context];
    this._FormControlDirective_5_5 = new import14.Wrapper_FormControlDirective((null as any),(null as any),this._NG_VALUE_ACCESSOR_5_4);
    this._NgControl_5_6 = this._FormControlDirective_5_5.context;
    this._NgControlStatus_5_7 = new import15.Wrapper_NgControlStatus(this._NgControl_5_6);
    this._text_6 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_0,'span',new import3.InlineArray2(2,'id','obpa_fulltext_err'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n        ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_7,(null as any));
    this._vc_9 = new import11.ViewContainer(9,7,this,this._anchor_9);
    this._TemplateRef_9_5 = new import18.TemplateRef_(this,9,this._anchor_9);
    this._NgIf_9_6 = new import16.Wrapper_NgIf(this._vc_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(this._el_7,'\n    ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import10.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_5,new import3.InlineArray4(4,'input',(null as any),'blur',(null as any)),this.eventHandler(this.handleEvent_5));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._text_11
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.DefaultValueAccessor) && (5 === requestNodeIndex))) { return this._DefaultValueAccessor_5_3.context; }
    if (((token === import20.NG_VALUE_ACCESSOR) && (5 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_5_4; }
    if (((token === import21.FormControlDirective) && (5 === requestNodeIndex))) { return this._FormControlDirective_5_5.context; }
    if (((token === import22.NgControl) && (5 === requestNodeIndex))) { return this._NgControl_5_6; }
    if (((token === import23.NgControlStatus) && (5 === requestNodeIndex))) { return this._NgControlStatus_5_7.context; }
    if (((token === import18.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import24.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    this._DefaultValueAccessor_5_3.ngDoCheck(this,this._el_5,throwOnChange);
    const currVal_5_1_0:any = this.context.fulltextFormControl;
    this._FormControlDirective_5_5.check_form(currVal_5_1_0,throwOnChange,false);
    this._FormControlDirective_5_5.ngDoCheck(this,this._el_5,throwOnChange);
    this._NgControlStatus_5_7.ngDoCheck(this,this._el_5,throwOnChange);
    const currVal_9_0_0:any = this.context.fulltextFormControl.invalid;
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    const currVal_20:any = this.context.searchForm.ctrlHasError(this.context.fulltextFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_20,currVal_20)) {
      this.renderer.setElementClass(this._el_0,'has-error',currVal_20);
      this._expr_20 = currVal_20;
    }
    valUnwrapper.reset();
    const currVal_21:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('SEARCH TERM')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_21,currVal_21))) {
      this.renderer.setText(this._text_3,currVal_21);
      this._expr_21 = currVal_21;
    }
    const currVal_23:any = true;
    if (import3.checkBinding(throwOnChange,this._expr_23,currVal_23)) {
      this.renderer.setElementAttribute(this._el_5,'aria-required',((currVal_23 == null)? (null as any): currVal_23.toString()));
      this._expr_23 = currVal_23;
    }
    const currVal_24:any = this.context.searchForm.ctrlHasError(this.context.fulltextFormControl);
    if (import3.checkBinding(throwOnChange,this._expr_24,currVal_24)) {
      this.renderer.setElementAttribute(this._el_5,'aria-invalid',((currVal_24 == null)? (null as any): currVal_24.toString()));
      this._expr_24 = currVal_24;
    }
    this._NgControlStatus_5_7.checkHost(this,this,this._el_5,throwOnChange);
  }
  destroyInternal():void {
    this._vc_9.destroyNestedViews();
    this._FormControlDirective_5_5.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 9)) { return new View_SearchFormFulltextComponent1(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    return (null as any);
  }
  handleEvent_5(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._DefaultValueAccessor_5_3.handleEvent(eventName,$event) && result);
    return result;
  }
}


// WEBPACK FOOTER //
// ./$$_gendir/src/app/search-panel/components/search-form-fulltext.component.ngfactory.ts